// extracted by mini-css-extract-plugin
var _1 = "SectionsTreeEditor_collapse__32375";
export { _1 as "collapse" }
